import { REDIRECT_URL_KEY, UNAUTHENTICATED_REDIRECT_URL } from '../constants/routingConstants'

/** Clear both auth return addresses when they match the destination being consumed. */
export const clearStoredAuthRedirects = (destination: string | null) => {
  if (!destination) return
  const storage = window.sessionStorage
  if (storage.getItem(REDIRECT_URL_KEY) === JSON.stringify(destination)) {
    storage.removeItem(REDIRECT_URL_KEY)
  }
  if (storage.getItem(UNAUTHENTICATED_REDIRECT_URL) === destination) {
    storage.removeItem(UNAUTHENTICATED_REDIRECT_URL)
  }
}

export const routeToCustomerLoginUrl = (customer: string, queryParams?: Record<string, string>) => {
  const currentCustomer = extractCustomerFromUrl()
  let redirectUrl = window.location.origin.replace(`${currentCustomer}.`, `${customer}.`) + '/login'
  if (queryParams) {
    const searchParams = new URLSearchParams(queryParams)
    redirectUrl += `?${searchParams.toString()}`
  }
  window.location.replace(redirectUrl)
}

const extractCustomerFromUrl = () => {
  const { host } = window.location
  return host.substring(0, host.indexOf('.'))
}
